export default __webpack_public_path__ + "static/media/failed.650f572c.svg";